import { render, staticRenderFns } from "./appLeft.vue?vue&type=template&id=0edaf924&scoped=true&"
import script from "./appLeft.vue?vue&type=script&lang=js&"
export * from "./appLeft.vue?vue&type=script&lang=js&"
import style0 from "./appLeft.vue?vue&type=style&index=0&id=0edaf924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edaf924",
  null
  
)

export default component.exports